import Service from "../../service/index";


const Circumstances = {
    namespaced: true,
    state: {
        circumstances: [],
    },
    mutations: {
        GET_CIRCUMSTANCES: (state, data) => {
            state.circumstances = data;
        },

    },
    actions: {
        setCircumstances({commit}){
            return Service.Circumstances.getCircumstances()
                .then(data=>{
                    commit("GET_CIRCUMSTANCES",data);
                })
        },
    }
};
export default Circumstances;
